<template>
        <div id='aboutus'>
              <NavTop title='关于我们'/>
              <div class='content'>
                <div class="topcon">
                    <div class="barcode">
                      <img src="~@/assets/img/aboutus.png"/>
                    </div>
                    <div class="barwords">
                       扫码或长按二维码关注公众号
                    </div>
                    <div class="contact">
                       联系方式：0571-89813702
                    </div>
                 </div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
export default {
  data(){
      return{
      }
  },  
  name: 'aboutus',
  components:{
      NavTop
  }
}
</script>
<style scoped>
#aboutus{background-color:#F6F6F6;min-height: 100vh;}
.content{display: flex;flex-flow: column nowrap;}
.topcon{display: flex;flex-flow: column nowrap;justify-content: center;align-items: center;}
.barcode{margin-top: 0.2rem;}
.barcode img {width:80%;}
.barwords{font-size: 0.3rem;color:#ccc;padding: 0.1rem;}
.contact{font-size: 0.45rem;color:#333;padding: 0.1rem;}
</style>


